import styled from 'styled-components'
import { fromPhone, belowPhone } from 'utilities/styled'
import { Wrapper as WrapperBase } from 'components/statistics-group'
import { HeroColumns } from 'pages/deviation/hero/s'
import { Item as ItemBase } from 'components/statistics-group/s'

export const Wrapper = styled(WrapperBase)`
    ${HeroColumns} + & {
        margin-block-start: 32px;

        ${belowPhone`
            margin-block-start: 24px;
        `}
    }

    ${fromPhone`
        margin-block-end: 16px;
    `}

    ${belowPhone`
        margin-block-end: 24px;
    `}
`

export const Item = styled(ItemBase)`
    label& {
        cursor: pointer;
    }
`
